module.exports = __webpack_public_path__ + "static/media/times-circle.6503d70f.svg";